"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _Arrow = _interopRequireDefault(require("../helpers/Arrow"));

var _useStencilPopper2 = require("../hooks/useStencilPopper");

var _context = require("../context");

var _utils = require("../utils");

var _AnimatedWrapper = _interopRequireDefault(require("./AnimatedWrapper"));

var _PopoverBody = _interopRequireDefault(require("./PopoverBody"));

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["children", "target", "close", "isOpen", "position", "shouldFocusOnOpen", "shouldCloseOnFocusLeave", "shouldOverflow", "onOpened", "onClosed", "onEscKey", "offset"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ZIndexWrapper = (0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: theme.selectors.zIndex('popover')
  };
});
ZIndexWrapper.displayName = 'ZIndexWrapper';

var PopoverControllerWithoutDocs = function PopoverControllerWithoutDocs(_ref2) {
  var children = _ref2.children,
      target = _ref2.target,
      close = _ref2.close,
      isOpen = _ref2.isOpen,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? _constants.PopoverControllerDefaultProps.position : _ref2$position,
      _ref2$shouldFocusOnOp = _ref2.shouldFocusOnOpen,
      shouldFocusOnOpen = _ref2$shouldFocusOnOp === void 0 ? _constants.PopoverControllerDefaultProps.shouldFocusOnOpen : _ref2$shouldFocusOnOp,
      _ref2$shouldCloseOnFo = _ref2.shouldCloseOnFocusLeave,
      shouldCloseOnFocusLeave = _ref2$shouldCloseOnFo === void 0 ? _constants.PopoverControllerDefaultProps.shouldCloseOnFocusLeave : _ref2$shouldCloseOnFo,
      _ref2$shouldOverflow = _ref2.shouldOverflow,
      shouldOverflow = _ref2$shouldOverflow === void 0 ? _constants.PopoverControllerDefaultProps.shouldOverflow : _ref2$shouldOverflow,
      onOpened = _ref2.onOpened,
      onClosed = _ref2.onClosed,
      onEscKey = _ref2.onEscKey,
      _ref2$offset = _ref2.offset,
      _offset = _ref2$offset === void 0 ? {} : _ref2$offset,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilDialogContext),
      hasOpenedDialog = _useContext.hasOpenedDialog;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      arrowElement = _useState2[0],
      setArrowElement = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      popoverBodyElement = _useState4[0],
      setPopoverBodyElement = _useState4[1];

  var popoverWrapperElement = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!popoverBodyElement) {
      return;
    }

    if (isOpen && shouldFocusOnOpen) {
      popoverBodyElement.focus({
        preventScroll: true
      });
    }
  }, [isOpen, shouldFocusOnOpen, popoverBodyElement]);
  var handleClickOutside = (0, _react.useCallback)(function (e) {
    if (!shouldCloseOnFocusLeave || !popoverBodyElement || !target.current) {
      return;
    }

    var eventPath = e.composedPath();
    var clickedInsidePopover = eventPath.includes(popoverBodyElement);
    var clickedTrigger = eventPath.includes(target.current);

    if (!clickedInsidePopover && !clickedTrigger) {
      close();
    }
  }, [shouldCloseOnFocusLeave, popoverBodyElement, close, target]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    if (!shouldCloseOnFocusLeave || !popoverBodyElement) {
      return;
    }

    var newFocusedElement = e.relatedTarget;

    if (!popoverBodyElement.contains(newFocusedElement) && newFocusedElement !== target.current) {
      setTimeout(function () {
        close();
      }, 100);
    }
  }, [shouldCloseOnFocusLeave, close, popoverBodyElement, target]);

  var handleEscapeKeydown = function handleEscapeKeydown(e) {
    if (!hasOpenedDialog && e.key === _utils.EventKeys.ESCAPE) {
      var _target$current;

      close();
      !!onEscKey && onEscKey(); //move the focus back to trigger element

      (_target$current = target.current) === null || _target$current === void 0 ? void 0 : _target$current.focus();
    }
  }; // Listen for click events on the document so the popover can be
  // closed if the user is clicking outside the popover body


  (0, _react.useEffect)(function () {
    window.addEventListener('click', handleClickOutside);
    return function () {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); // Listen for blur events on the target element so the popover can be
  // closed if the user is tabbing backwards through the DOM

  (0, _react.useEffect)(function () {
    var targetRefValue = null;

    if (target.current) {
      targetRefValue = target.current;
      target.current.addEventListener('blur', handleBlur);
    }

    return function () {
      if (targetRefValue) {
        targetRefValue.removeEventListener('blur', handleBlur);
      }
    };
  }, [target, handleBlur]);
  var popperPlacement = _constants.POPPER_JS_POSITION_MAPPER[position];
  var popperModifiers = [{
    name: 'offset',
    options: {
      offset: function offset(_ref3) {
        var _defaultOffsets;

        var placement = _ref3.placement;
        var defaultOffsets = (_defaultOffsets = {}, (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.TopCenter, [0, 0]), (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.TopLeading, [-_constants.ARROW_HEIGHT, 0]), (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.TopTrailing, [_constants.ARROW_HEIGHT, 0]), (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.BottomCenter, [0, 0]), (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.BottomLeading, [-_constants.ARROW_HEIGHT, 0]), (0, _defineProperty2.default)(_defaultOffsets, _interfaces.PopoverPosition.BottomTrailing, [_constants.ARROW_HEIGHT, 0]), _defaultOffsets);
        var currentPosition = _constants.POPPER_JS_REVERSE_POSITION_MAPPER[placement];
        var positionOffset = _offset[currentPosition] || defaultOffsets[currentPosition];

        if (!!positionOffset) {
          return [positionOffset[0], _constants.ARROW_HEIGHT + positionOffset[1]];
        }

        return [0, _constants.ARROW_HEIGHT];
      }
    }
  }, {
    name: 'arrow',
    options: {
      element: arrowElement
    }
  }, {
    name: 'arrowPosition',
    enabled: true,
    requires: ['arrow'],
    phase: 'main',
    fn: function fn(_ref4) {
      var state = _ref4.state;
      return (0, _utils2.modifyArrowPosition)({
        state: state
      });
    }
  }];

  if (!shouldOverflow) {
    popperModifiers.push({
      name: 'flip',
      options: {
        fallbackPlacements: (0, _utils2.getFallbackPlacements)(popperPlacement)
      }
    });
  }

  var _useStencilPopper = (0, _useStencilPopper2.useStencilPopper)(target.current, popoverWrapperElement.current, !!isOpen, {
    placement: popperPlacement,
    modifiers: popperModifiers
  }),
      styles = _useStencilPopper.styles,
      placement = _useStencilPopper.placement;

  var arrow = (0, _core.jsx)("div", {
    ref: setArrowElement,
    style: _objectSpread(_objectSpread({}, styles.arrow), {}, {
      width: _constants.ARROW_WIDTH,
      zIndex: 1 // So that it's on top of the popover body

    })
  }, (0, _core.jsx)(_Arrow.default, {
    size: _constants.ARROW_HEIGHT,
    borderColor: "neutral20",
    direction: (0, _utils2.getArrowDirection)(placement)
  }));
  return (0, _core.jsx)(ZIndexWrapper, {
    ref: popoverWrapperElement,
    style: styles.popper
  }, (0, _core.jsx)(_AnimatedWrapper.default, {
    isOpen: !!isOpen,
    onOpened: onOpened,
    onClosed: onClosed,
    isAboveTrigger: (0, _utils2.isTop)(placement)
  }, arrow, (0, _core.jsx)(_PopoverBody.default, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    ref: setPopoverBodyElement,
    tabIndex: -1,
    onBlur: function onBlur(e) {
      return handleBlur(e.nativeEvent);
    },
    onKeyDown: handleEscapeKeydown
  }), children)));
};

var PopoverControllerWithDocs = (0, _stencilReactDesc.describe)(PopoverControllerWithoutDocs).description('Displays content in a popover attached to a given reference element.');
PopoverControllerWithDocs.propTypes = _objectSpread({}, _propTypes.popoverControllerPropTypes);
var PopoverController = (0, _utils.withTestAttributes)({
  component: 'StencilPopover'
})(PopoverControllerWithDocs);
PopoverController.displayName = 'PopoverController';
PopoverController.defaultProps = _objectSpread({}, _constants.PopoverControllerDefaultProps);
var _default = PopoverController;
exports.default = _default;